export default __webpack_public_path__ + "static/media/about.6b66d2e3.jpg";